import { ReactElement } from 'react';

import isArray from 'lodash/isArray';
import toString from 'lodash/toString';

export interface IFormCondition {
    when?: string | number;
    is?: string | number | string[] | number[];
    children: ReactElement;
}

export const FormCondition = ({ when, is, children }: IFormCondition) => {
    if (!when || !is) return null;

    const isAvailable = isArray(is)
        ? (is as []).find(arg => toString(arg) === toString(when))
        : toString(is) === toString(when);
    return isAvailable ? children : null;
};
